<mat-select [formControl]="ngControl.control" [(value)]="value" disableOptionCentering panelClass="{{ showBMSTheme ? 'bms-theme' : '' }}">
  <mat-select-trigger>
    <div [ngClass]="showBMSTheme ? '' : 'container'">
      @if (ngControl.value && !showBMSTheme) {
        <vdw-pattern [pattern]="ngControl.value"></vdw-pattern>
      }
      @if (!ngControl.value && ngControl.value > 0 && !showBMSTheme) {
        <div></div>
      }
      {{ 'ANGULAR_COMPONENT_LIBRARY.SELECT_PATTERN.' + patternEnum[ngControl?.value] | bmsTranslate }}
    </div>
  </mat-select-trigger>
  @for (pattern of patterns; track pattern) {
    <mat-option [attr.value]="pattern" [value]="pattern">
      <div [ngClass]="showBMSTheme ? 'reverse-container' : 'container'">
        @if (pattern) {
          <vdw-pattern [pattern]="pattern"></vdw-pattern>
        }
        @if (showBMSTheme) {
          <div></div>
        }
        {{ 'ANGULAR_COMPONENT_LIBRARY.SELECT_PATTERN.' + patternEnum[pattern] | bmsTranslate }}
      </div>
    </mat-option>
  }
</mat-select>
